// src/utils/streamClient.js
import { api } from "../api";

const DEBUG_SSE = true;
const PREFIX = "[AGENDA-SSE]";

// mesmo helper de URL que usamos no Sidebar
const absURL = (path) => {
  const base = api?.defaults?.baseURL || window.location.origin;
  const u = new URL(base);
  const basePath = u.pathname.replace(/\/+$/, "");

  if (path.startsWith("/")) {
    // força na raiz do host da API
    return `${u.origin}${path}`;
  }

  return `${u.origin}${basePath ? basePath + "/" : "/"}${path}`;
};

/**
 * Inicia o SSE **apenas** para Agenda/Lembretes.
 *
 * @param {number} userId  IdFuncionario / usuário logado
 * @param {(type: string, payload: any) => void} onEvent callback por evento
 * @returns {() => void} função stop() para encerrar o stream
 */
export function initStream(userId, onEvent) {
  if (!userId) {
    if (DEBUG_SSE) console.warn(`${PREFIX} initStream sem userId, abortando.`);
    return () => {};
  }

  // EventSource não aceita header custom com facilidade, então usamos query ?userId=
  const qs = `userId=${encodeURIComponent(userId)}`;
  const url = absURL(`/ssw/agenda/stream?${qs}`);

  if (DEBUG_SSE) console.info(`${PREFIX} abrindo stream:`, url);

  const es = new EventSource(url); // browser faz o reconnect automático

  es.onopen = () => {
    if (DEBUG_SSE)
      console.info(`${PREFIX} conexão SSE aberta para userId=${userId}`);
  };

  es.onerror = (ev) => {
    if (DEBUG_SSE) console.warn(`${PREFIX} erro na conexão SSE:`, ev);
    // EventSource tenta reconectar sozinho; não fechamos aqui
  };

  es.onmessage = (ev) => {
    if (!ev?.data) return;

    if (DEBUG_SSE) {
      console.log(`${PREFIX} raw message:`, ev.data);
    }

    try {
      const data = JSON.parse(ev.data);
      const type = data.type || data.event || "UNKNOWN";
      const payload = data.payload ?? data;

      if (DEBUG_SSE) {
        // Aqui você deve ver:
        // [AGENDA-SSE] message: PING { ok: true }
        // [AGENDA-SSE] message: AGENDA_REMINDER {...}
        console.info(`${PREFIX} message:`, type, payload);
      }

      if (typeof onEvent === "function") {
        onEvent(type, payload);
      }
    } catch (err) {
      if (DEBUG_SSE) {
        console.error(
          `${PREFIX} falha ao parsear mensagem SSE:`,
          err,
          ev.data
        );
      }
    }
  };

  // função de cleanup usada pelo SseBoot
  return () => {
    if (DEBUG_SSE) console.info(`${PREFIX} fechando stream para userId=${userId}`);
    try {
      es.close();
    } catch (_) {
      // ignore
    }
  };
}
